<template>

  <el-form size="mini" :loading="isLoading">
    <el-form-item label="De:">
      <el-select v-model="anoSelected">
        <el-option v-for="ano in anos" :value="ano" :key="ano"> {{ano}}</el-option>
      </el-select>
      <el-select v-model="mesSelected" value-key="mes">
        <el-option v-for="mes in meses" :key="mes.mes" :label="mes.nome" :value="mes.mes"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button @click="onSubmit" type="primary">Copiar</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import {Notification} from 'element-ui'
  import {trataErrors, competenciaIsOpen} from '@/domain/utils'
  import {mapState} from 'vuex'

  export default {
    name: "competencia-copia",
    props: ['competencia'],
    data() {
      return {
        isLoading: false,
        mesSelected: null,
        anoSelected: null
      }
    },
    computed: {
      ...mapState(['anos', 'meses'])
    },
    methods: {
      async onSubmit() {
        try {
          this.isLoading = true;
          const uri = `${process.env.API_PATH}/competencia/copia/${this.anoSelected}/${this.mesSelected}`;
          const {data} = await axios.put(uri);
          this.processos = [...data];
          this.$notify.success( 'Cópia efetuada com sucesso.');
        } catch (error) {
          trataErrors(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Competencia/Copia.vue